import { styled } from "@mui/material";

export const CalenderWrapper = styled("div")(({ offset }) => ({
  position: "absolute",
  left: offset < 200 ? "0" : "auto",
}));
